import { CaptorMessageChannels } from "../message";
export const QueryTypes = CaptorMessageChannels;
//# sourceMappingURL=captor.js.map